/**
 * AlertDevice type constants.
 *
 * Mirrors the backend's AlertDevice::CHECKIN_TYPE and similar constants
 * in airagri-backend/modules/api/models/AlertDevice.php. The string
 * values must match the backend exactly — they are persisted to the
 * `alert_devices.type` column and consumed on both sides.
 *
 * If you add a new type here, update the backend model (and any cron
 * dispatch in IotReportEventController) in the same PR.
 */

export const ALERT_DEVICE_TYPE_CHECKIN = 'checkin';
